var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"exploitation-card",attrs:{"fluid":""}},[_c('b-row',{staticClass:"justify-content",attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"pr-0",attrs:{"cols":"auto"}},[_c('span',{staticClass:"h3"},[_c('AccountMenuIcon')],1)]),_c('b-col',[_vm._v(" "+_vm._s(_vm.prenomNom)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }